import { z } from 'zod';

import { ParticipantZod } from 'types/zod/participant';
import { UserZod } from 'types/zod/user';

export const CurrentParticipantZod = ParticipantZod.and(
    z.object({
        first_name: z.string(),
        full_name: z.string(),
        last_name: z.string(),
        generated_once: z.boolean().optional(),
        isPasswordChangeRequired: z.boolean().optional(),
        user: UserZod,
        directInvoicing: z.boolean().optional(),
    }),
);
export type CurrentParticipant = z.infer<typeof CurrentParticipantZod>;
